import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrenceByLocalAndGender = () => {
    const { chartData } = useServicesChartsDataContext();
    
    const center = [-15.7801, -47.9292];

    const tableColumns = [
            {
                key: 'bairro',
                header: 'Bairro',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'feminino',
                header: 'Feminino',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'masculino',
                header: 'Masculino',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'nao_informado',
                header: 'Não Informado',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '500', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    return (
        <div style={{ width: '100%', display: 'flex' }}>
            {/* <MapContainer
                center={center}
                zoom={4}
                className="leaflet-container-dashboards"
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {chartData?.ocurrenceByLocalAndGender?.mapItems?.map((neighbourhood, index) => (
                    <Marker
                        key={index}
                        position={[neighbourhood.latitude, neighbourhood.longitude]}
                        icon={
                            new L.Icon({
                                iconUrl:
                                    'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
                                shadowUrl:
                                    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png',
                                iconSize: [25, 41],
                                iconAnchor: [12, 41],
                                popupAnchor: [1, -34],
                                shadowSize: [41, 41]
                            })
                        }
                    >
                        <Popup>{neighbourhood.description}</Popup>
                    </Marker>
                ))}
            </MapContainer> */}
            <TableComponent
                data={chartData?.ocurrenceByLocalAndGender?.listItems}
                columns={tableColumns}
                title="Ocorrências por setor e sexo"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};